import PageMobile from "./page-mobile-container";

export default PageMobile;